export default function LogoMark({
  className,
  size = 'big',
}: {
  className?: string;
  size?: 'big' | 'small';
}) {
  return (
    <svg
      width={size === 'big' ? '48' : '20'}
      height={size === 'big' ? '48' : '20'}
      viewBox="0 0 384 384"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M224 27.9995V59.9995C224 150.574 150.575 224 60 224H28V152H60C110.81 152 152 110.81 152 59.9995V27.9995H224Z" />
      <path d="M355.999 316C355.999 338.092 338.09 356 315.999 356C293.908 356 275.999 338.092 275.999 316C275.999 293.909 293.908 276 315.999 276C338.09 276 355.999 293.909 355.999 316Z" />
      <path d="M151.994 316.001V348.001H223.994V316.001C223.994 265.191 265.184 224.001 315.994 224.001H347.994V152.001H315.994C225.419 152.001 151.994 225.426 151.994 316.001Z" />
    </svg>
  );
}
